module.exports = __webpack_public_path__ + "static/media/bc_risk_factors.e1458a01.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd552/bc_risk_factors.JPG
// module id = 58
// module chunks = 0